import React from "react";
import { Lock, Sparkles } from "lucide-react";
import { usePlan } from "../context/PlanContext";

export const UpgradeLock = ({ feature, children, compact = false, hint }) => {
  const { has, planFor, goPlans } = usePlan();
  if (has(feature)) return children;
  const plan = planFor(feature);
  return (
    <div className="relative" data-testid={`locked-${feature}`}>
      <div className="opacity-40 pointer-events-none select-none blur-[1px]" aria-hidden="true">{children}</div>
      <div className="absolute inset-0 flex items-center justify-center p-4">
        <div className={`bg-white/95 backdrop-blur rounded-2xl shadow-[0_12px_32px_rgba(20,30,55,0.15)] border border-gray-100 text-center ${compact ? "px-4 py-3" : "px-6 py-5 max-w-sm"}`}>
          <p className="font-semibold text-[#16243b] flex items-center justify-center gap-1.5 text-sm"><Lock size={15} className="text-[#2ec9c9]" /> {plan ? `Available on ${plan.name}` : "Not available on your plan"}</p>
          {!compact && plan && <p className="text-xs text-[#8a97a8] mt-1">{hint || plan.tagline}</p>}
          {plan && (
            <button type="button" onClick={goPlans} data-testid={`upgrade-btn-${feature}`}
              className="gp-btn-teal mt-3 rounded-full px-4 py-2 text-xs font-semibold inline-flex items-center gap-1.5">
              <Sparkles size={13} /> Upgrade to {plan.name}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
